import {Collapse, Typography, withStyles} from "@material-ui/core";
import React, {useState} from "react";
import GridBlock from "components/GridBlock";
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import Checkbox from "components/Checkbox";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import BoldTypography from "components/BoldTypography";
import clsx from "clsx";
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
    root: {
        '&>*:nth-child(1)': {
            flexGrow: 1,
        }
    },
    title: {
        marginLeft: theme.spacing(),
        wordBreak: 'break-all',
        cursor: 'pointer'
    },
    approver: {
        marginLeft: theme.spacing(4)
    },
    approverList: {
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4)
    },
    error: {
        color: theme.palette.error.main
    }
})

function StageApprovers(
    {
        id,
        stage,
        opened,
        formikProps,
        classes
    }) {

    const [open, setOpen] = useState(opened);
    const isError = stage.approvers.some((a, i) => getObjectValue(`${id}.approvers.${i}.selected`, formikProps.errors, false));

    return (<>
        <GridBlock
            alignItems='center'
            className={classes.root}
            wrap='nowrap'
        >
            <BoldTypography
                variant='body1'
                className={classes.title}
                onClick={() => setOpen(!open)}
            >
                {stage.name}
            </BoldTypography>

            <GridBlock wrap='nowrap'>
                <WorkableIconExpandButton
                    color='primary'
                    onClick={() => setOpen(!open)}
                    expanded={open}
                />
            </GridBlock>
        </GridBlock>

        <Collapse in={open}>
            <GridBlock
                direction='column'
                className={classes.approverList}
            >
                <Typography className={clsx({[classes.error]: isError})}>{Tr('selectApproversMinCountInfo', {count: stage.minAssignedApproverCount})}</Typography>
                {stage.approvers.map((approver) => {
                    const index = stage.approvers.map(a => a.identity).indexOf(approver.identity);
                    return (
                        <Checkbox
                            key={`aid${approver.identity}`}
                            id={`${id}.approvers.${index}.selected`}
                            label={`${approver.firstName} ${approver.lastName} (${approver.email})`}
                            formikProps={formikProps}
                        />
                    )
                })}
                <TextInput
                    id={`${id}.assigneeComment`}
                    label={Tr('selectApproversAssigneeComment')}
                    formikProps={formikProps}
                    limit={255}
                    multiline
                    required={stage.useAssignerComments}
                />
            </GridBlock>
        </Collapse>
    </>)
}

export default withStyles(style)(StageApprovers)